import TemplateNames from '../email-messages/TemplateNames';

export default {
  template_names: TemplateNames,
  email_messages_page_title: 'Sähköpostiviestit',
  labels: {
    view_full_message: 'Näytä koko viesti',
    status: 'Tila:',
    on: 'Päällä',
    off: 'Pois',
  },
  tiles: {
    sends_count: 'Viestejä lähetetty',
    delivery_rate: 'Toimitusprosentti',
    delivered_suffix: 'toimitettu',
    open_rate: 'Avausprosentti',
    opened_suffix: 'avattu',
    click_rate: 'Napsautusprosentti',
    clicked_suffix: 'napsautettu',
    spam_report_rate: 'Roskapostiraporttien osuus',
    spam_reports_suffix: 'raporttia',
    unsubscribe_rate: 'Tilauksen peruutusprosentti',
    unsubscribes_suffix: 'peruutusta',
  },
  toasts: {
    failed_to_update_status: 'Tilan päivitys epäonnistui',
    failed_to_load_data: 'Tietojen lataaminen epäonnistui',
  },

  preview_modal: {
    title: 'Mallin esikatselu',
    labels: {
      subject: 'Aihe:',
      close: 'Sulje',
    },
    toasts: {
      failed_to_load_data: 'Esikatselutietojen lataaminen epäonnistui',
    },
    template_data: {
      recipient_name: '&lt;Etunimi&gt;',
    },
  },
};
